export default "__VITE_ASSET__826fd341__"